<template>
  <div class="report-type-input-wrapper">
    <!-- 设计模式（占位） -->
    <div v-if="mode === 'DESIGN'" class="design-mode">
      <p class="placeholder-text">报表类型输入组件 - 设计模式</p>
    </div>

    <!-- PC端 可编辑 -->
    <div v-else-if="mode === 'PC' && !readonly" class="common-mode">
      <div v-for="(item, index) in detailList" :key="item.id || index" class="report-item">
        <div class="report-header-row">
          <span class="report-name">{{ item.name }}</span>
          <span class="report-desc">说明：{{ item.description }}</span>
        </div>
        <div class="template-row" v-if="item.template">
          <span class="template-label">模板：</span>
          <el-button
              v-for="(tpl, idx) in parsedTemplate(item.template)"
              :key="tpl.id || idx"
              type="text"
              class="template-btn"
              @click="downLoadTemplate(tpl)"
          >
            {{ tpl.name }}
          </el-button>
          <span
              class="divider"
              v-for="(tpl, idx) in parsedTemplate(item.template)"
              :key="`div-${idx}`"
              v-if="idx < parsedTemplate(item.template).length - 1"
          >|</span>
        </div>
        <div class="upload-row">
          <el-upload
              ref="upload"
              :action="upload.url + '?updateSupport=' + upload.updateSupport"
              :disabled="upload.isUploading || readonly"
              :headers="upload.headers"
              :show-file-list="false"
              :on-progress="handleFileUploadProgress"
              multiple
              :on-success="(response, file, fileList) => handleFileSuccess(response, file, fileList, item)"
              :on-remove="(file, fileList) => handleFileRemove(file, fileList, item)"
          >
            <el-button size="small" icon="el-icon-paperclip" round :disabled="readonly">选择文件</el-button>
          </el-upload>
          <div class="uploaded-files" v-if="fileMap[item.id]?.filter(f => f.url).length">
            <div v-for="(file, idx) in fileMap[item.id].filter(f => f.url)" :key="idx" class="file-item">
              <el-button type="text" class="file-name-btn" @click="handleDownLoad(file.url)">{{ file.urlName }}</el-button>
              <i class="el-icon-close file-delete-btn" @click.stop="handleFileDelete(file.url, item)"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 小程序(MOBILE)端 可编辑 -->
    <div v-else-if="mode === 'MOBILE' && !readonly" class="common-mode">
      <div v-for="(item, index) in detailList" :key="item.id || index" class="report-item">
        <div class="report-header-row">
          <span class="report-name">{{ item.name }}</span>
          <span class="report-desc">说明：{{ item.description }}</span>
        </div>
        <div class="template-row" v-if="item.template">
          <span class="template-label">模板：</span>
          <el-button
              v-for="(tpl, idx) in parsedTemplate(item.template)"
              :key="tpl.id || idx"
              type="text"
              class="template-btn"
              @click="downLoadTemplate(tpl)"
          >
            {{ tpl.name }}
          </el-button>
          <span
              class="divider"
              v-for="(tpl, idx) in parsedTemplate(item.template)"
              :key="`div-${idx}`"
              v-if="idx < parsedTemplate(item.template).length - 1"
          >|</span>
        </div>
        <div class="upload-row">
          <uploader
              upload-text="选择文件"
              upload-icon="description"
              accept="*"
              :show-upload-list="false"
              :after-read="(file) => mobileUpload(file, item)"
          ></uploader>
          <div class="uploaded-files" v-if="fileMap[item.id]?.filter(f => f.url).length">
            <div v-for="(file, idx) in fileMap[item.id].filter(f => f.url)" :key="idx" class="file-item">
              <el-button type="text" class="file-name-btn" @click="handleDownLoad(file.url)">{{ file.urlName }}</el-button>
              <i class="el-icon-close file-delete-btn" @click.stop="mobileFileRemove(file.url, item)"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 只读模式（PC/MOBILE共用） -->
    <div v-else class="common-mode readonly-mode">
      <div v-for="(item, index) in detailList" :key="item.id || index" class="report-item">
        <div class="report-header-row">
          <span class="report-name">{{ item.name }}</span>
          <span class="report-desc">说明：{{ item.description }}</span>
        </div>
        <div class="template-row" v-if="item.template">
          <span class="template-label">模板：</span>
          <el-button
              v-for="(tpl, idx) in parsedTemplate(item.template)"
              :key="tpl.id || idx"
              type="text"
              class="template-btn"
              @click="downLoadTemplate(tpl)"
          >
            {{ tpl.name }}
          </el-button>
          <span
              class="divider"
              v-for="(tpl, idx) in parsedTemplate(item.template)"
              :key="`div-${idx}`"
              v-if="idx < parsedTemplate(item.template).length - 1"
          >|</span>
        </div>
        <div class="upload-row">
          <span class="readonly-upload-text">选择文件</span>
          <div class="uploaded-files" v-if="fileMap[item.id]?.filter(f => f.url).length">
            <div v-for="(file, idx) in fileMap[item.id].filter(f => f.url)" :key="idx" class="file-item">
              <el-button type="text" class="file-name-btn" @click="handleDownLoad(file.url)">{{ file.urlName }}</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Field, Popup, Picker, Radio, RadioGroup, Uploader, Toast } from 'vant';
import componentMinxins from '../ComponentMinxins'
import { getReportDetailsByTenant } from '@/api/ops/report';

export default {
  mixins: [componentMinxins],
  name: "ReportTypeInput",
  components: { Radio, RadioGroup, Picker, Field, Popup, Uploader },
  props: {
    value: { type: String, default: null },
    placeholder: { type: String, default: '请选择选项' },
    expanding: { type: Boolean, default: false },
    options: { type: Array, default: () => [] },
    propValue: { type: Object, default: () => {} },
    formData: { type: Object, default: () => {} },
    readonly: { type: Boolean, default: false },
    tenant: { type: String, default: null }
  },
  data() {
    return {
      showPicker: false,
      templateList: [],
      detailList: [],
      fileMap: {},
      upload: {
        isUploading: false,
        updateSupport: 0,
        headers: { Authorization: "Bearer " + localStorage.getItem("wflow-token") },
        url: this.BASE_URL + "/system/report/importData"
      }
    }
  },
  created() {
    const selectedIds = Array.isArray(this.propValue.report) ? this.propValue.report : [];
    if (this.value && typeof this.value === 'string') {
      try {
        this.fileMap = JSON.parse(this.value);
        selectedIds.forEach(id => {
          getReportDetailsByTenant(this.tenant, id).then(res => {
            this.detailList.push(...res.data)
          })
        })
      } catch (e) {
        console.warn('解析历史数据失败');
      }
    } else {
      this.templateList = this.options.filter(item => selectedIds.includes(item.id));
      selectedIds.forEach(id => {
        getReportDetailsByTenant(this.tenant, id).then(res => {
          this.detailList.push(...res.data)
          res.data.forEach(item => {
            this.$set(this.fileMap, item.id, [{
              id: item.id,
              name: item.name,
              description: item.description
            }])
          })
        })
      })
    }
    setTimeout(() => { this.$forceUpdate() }, 300)
  },
  methods: {
    // ========== 小程序端上传 ==========
    mobileUpload(file, item) {
      const formData = new FormData();
      formData.append("file", file.file);
      Toast.loading({ message: "上传中...", forbidClick: true, duration: 0 });
      this.$axios
          .post(this.upload.url, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + localStorage.getItem("wflow-token"),
            },
          })
          .then((res) => {
            if (res.status === 200 && res.data) {
              const response = res.data;
              if (response.url) {
                const fileId = item.id;
                if (!this.fileMap[fileId]) {
                  this.$set(this.fileMap, fileId, [{
                    id: fileId, name: item.name, description: item.description,
                    urlName: response.name || file.name, url: response.url
                  }]);
                } else {
                  this.fileMap[fileId].push({
                    id: fileId, name: item.name, description: item.description,
                    urlName: response.name || file.name, url: response.url
                  });
                }
                this._value = JSON.stringify(this.fileMap);
                this.$forceUpdate();
                Toast.success("上传成功");
              } else {
                Toast.fail("上传失败");
              }
            }
          })
          .catch((err) => {
            console.error(err);
            Toast.fail("上传失败");
          })
          .finally(() => {
            Toast.clear();
          });
    },

    // ========== 删除文件 ==========
    handleFileDelete(fileUrl, item) {
      const fileId = item.id;
      if (this.fileMap[fileId]) {
        this.$set(
            this.fileMap,
            fileId,
            this.fileMap[fileId].filter(f => f.url !== fileUrl)
        );
        this._value = JSON.stringify(this.fileMap);
        this.$forceUpdate();
      }
    },

    mobileFileRemove(fileUrl, item) {
      this.handleFileDelete(fileUrl, item);
    },

    // ========== 公共方法 ==========
    parsedTemplate(templateStr) {
      try { return JSON.parse(templateStr || '[]') }
      catch (e) { return [] }
    },
    onConfirm(val) {
      this.showPicker = false
      this._value = val
    },
    handleFileUploadProgress(event, file, fileList) {
      this.upload.isUploading = true;
    },
    handleFileSuccess(response, file, fileList, item) {
      this.upload.isUploading = false;
      if (response?.url) {
        const fileId = item.id;
        if (!this.fileMap[fileId]) {
          this.$set(this.fileMap, fileId, [{
            id: fileId, name: item.name, description: item.description,
            urlName: response.name, url: response.url
          }]);
        } else {
          this.fileMap[fileId].push({
            id: fileId, name: item.name, description: item.description,
            urlName: response.name, url: response.url
          });
        }
        this._value = JSON.stringify(this.fileMap);
      }
    },
    handleFileRemove(file, fileList, item) {
      if (file.response?.url) {
        if (this.fileMap[item.id]?.length <= 1) {
          this.$set(this.fileMap, item.id, [{ id: item.id, name: item.name, description: item.description }]);
        } else {
          this.$set(
              this.fileMap,
              item.id,
              this.fileMap[item.id].filter(f => f.url !== file.response.url)
          );
        }
        this._value = JSON.stringify(this.fileMap);
      }
    },
    handleDownLoad(url) { window.open(url) },
    downLoadTemplate(template) {
      const link = document.createElement('a');
      link.href = template.url;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}
</script>

<style scoped>
.report-type-input-wrapper {
  width: 100%;
  box-sizing: border-box;
  font-size: 14px;
}

.design-mode {
  padding: 15px;
  background: #f5f7fa;
  border-radius: 8px;
  text-align: center;
  color: #909399;
}

.common-mode {
  width: 100%;
}

.report-item {
  background: #f0f2f5;
  border-radius: 4px;
  padding: 10px;
  margin-bottom: 8px;
  width: 100%;
  box-sizing: border-box;
  word-break: break-all;
}

.report-item:last-child {
  margin-bottom: 0;
}

.report-header-row {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 6px;
}

.report-name {
  font-weight: bold;
  color: #333;
  white-space: nowrap;
}

.report-desc {
  color: #333;
  line-height: 1.4;
}

.template-row {
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.template-label {
  color: #333;
  margin-right: 5px;
}

.template-btn {
  font-size: 13px !important;
  color: #409eff !important;
  padding: 0 5px !important;
}

.divider {
  color: #999;
  font-size: 13px;
  margin: 0 3px;
}

.upload-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.upload-btn {
  font-size: 13px;
}

/* 只读模式的灰色"选择文件" */
.readonly-upload-text {
  color: #c0c4cc;
  cursor: not-allowed;
  font-size: 14px;
  user-select: none;
}

.uploaded-files {
  margin-top: 4px;
}

.file-item {
  margin-top: 2px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.file-name-btn {
  font-size: 13px !important;
  color: #409eff !important;
  padding: 0 !important;
  text-align: left !important;
}

.file-delete-btn {
  color: #f56c6c;
  cursor: pointer;
  font-size: 14px;
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .report-item {
    padding: 8px;
  }
  .report-header-row {
    flex-direction: column;
    gap: 4px;
  }
}
</style>
